import { AppState } from 'common/appState';

export const getFetchingDownloadStatus = (state: AppState) => state.download.isFetching;
